import React, { memo } from "react";
import PropTypes from "prop-types";
import { IconButton, Tooltip } from "@toddle-edu/ds-web";
import { SortOutlined } from "@toddle-edu/ds-icons";

const DisplaySettingsButton = ({ onClick, tooltip, testId, size }) => {
  return (
    <Tooltip tooltip={tooltip}>
      <IconButton
        type="outlined"
        variant="neutral"
        icon={<SortOutlined />}
        onClick={onClick}
        testId={testId}
        size={size}
      />
    </Tooltip>
  );
};

DisplaySettingsButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  tooltip: PropTypes.string.isRequired,
  testId: PropTypes.string,
  size: PropTypes.oneOf(["small", "medium", "large"]),
};

DisplaySettingsButton.defaultProps = {
  testId: undefined,
  size: "medium",
};

export default memo(DisplaySettingsButton);
